window.$ = window.jQuery = require('jquery');
require('./vendor.min');
require('popper.js');
require('bootstrap');
require('owl.carousel'); 
require('jquery-dateformat/dist/jquery-dateFormat');

// require('paroller.js');
window.Dropzone = require('dropzone');
Dropzone.autoDiscover = false;

$(document).ready(function() {
    if($('.home-blog #blogResults').length > 0){
        $(function () {
            let $content = $('#blogResults');
            let data = {
                rss_url: 'https://blog.satoripop.com/feed'
            };
            $.get('https://api.rss2json.com/v1/api.json', data, function (response) {
            if (response.status == 'ok') {
                let output = '';
                
                $.each(response.items, function (k, item) {
                    
                    let tagIndex = item.description.indexOf('<img'); // Find where the img tag starts
                    let srcIndex = item.description.substring(tagIndex).indexOf('src=') + tagIndex; // Find where the src attribute starts
                    let descriptionStart = item.description.indexOf('<p>');
                    let descriptionEnd = item.description.indexOf('</p>');
                    let srcStart = srcIndex + 5; // Find where the actual image URL starts; 5 for the length of 'src="'
                    let srcEnd = item.description.substring(srcStart).indexOf('"') + srcStart; // Find where the URL ends
                    let src = item.description.substring(srcStart, srcEnd); // Extract just the URL
                    let description = item.description.substring(descriptionStart, descriptionEnd);
                    if(description.length > 124 )
                    {
                        desc = description.replace('<a href="https://medium.com/u/22562d023d28">', '');
                        desc = desc.replace('</a>', '');
                        description = desc.substring(3, 122);
                    }
                    output += '<div class="item">';
                    output += '<img src="' + src + '" class="img-fluid" alt="' + item.title + '">';
                    output += '<div class="description"> <h3>' + item.title + '</h3>';
                    output += '<div class="author">' + item.author + '</div> ';
                    output += '<div class="date">' + $.format.date(item.pubDate, 'MMMM  d, yyyy') + '</div> </div></div>';
                    return k < 3;
                });
                $content.html(output);
            }
        });
    });
    $('.home-testemonials .owl-carousel').owlCarousel({
        center: true,
        loop:true,
        margin:20,
        nav: false,
        dots: false,
        items: 6,
        responsiveClass:true,
        responsive:{
            0:{
                items:1,
                nav:true
            },
            600:{
                items:1,
                nav:true,
            },
            800:{
                items:2,
                nav:true,
            },
            900:{
                items:2,
                nav:true,
            },
            1000:{
                items:2,
                nav:true,
            },
            1400:{
                items:3,
                nav:true,
            }
        }
    })


    $(function () {
        $('.map .owl-carousel').owlCarousel({
           margin: 0,
           navSpeed: 500,
           nav: false,
           items: 1,
           loop: false,
           autoplay: true,
           autoplayTimeout: 8000,
           autoplayHoverPause: true,
           animateOut: 'fadeOut',
           animateIn: 'fadeIn'
         });
       });

    $('.partner').hover(
        function(){
          $(this).attr('src', $(this).data('hover'));
        },
        function(){
            $(this).attr('src', $(this).data('not-hovered'))
        }
    )
}

function position($el){
    var wTop = $(window).scrollTop();
    var wBot = wTop + $(window).height();
    var eTop = $el.offset().top;
    var eBot = eTop + $el.height();
    return ((eBot <= (wBot + 10 )) && (eTop >= (wTop + 100)));
}
function setInView(){
    $(".box").each(function(){
        var $zis = $(this);
        $zis.removeClass("hovered");
        if(position($zis)){
           $zis.toggleClass("hovered");
        }
    });
}

if($(window).width() < 767)
{
    $(document).scroll(function(){
        setInView();
    });
    $(document).resize(function(){
        setInView();
    });
    $(document).ready(function(){
        setInView();
    });
}

// Add active class to first item in a carousel slider
$("#carouselSatoripop.carousel .carousel-item:first").addClass("active");
$("#carouselSatoripop.carousel .carousel-indicators>li:first").addClass("active");
$("#carouselMaskSlider.carousel .carousel-item:first").addClass("active"); 
$("#carouselTestemonials.carousel .carousel-item:first").addClass("active");
//$("#carouselCaseStudies.carousel .carousel-item:first").addClass("active");

// Add class last to the last step of a case study
$(".the-process .process-steps .step:not(:first):last").addClass("last"); 

//Scroll back to top
$('.scroll-back').hide();
$(window).scroll(function(){
    if ($(this).scrollTop() > 300) {
        $('.scroll-back').show().fadeIn();
    } else {
        $('.scroll-back').fadeOut().hide();
    }
});
$('.scroll-back').click(function(){
    $('html, body').animate({scrollTop : 0},360);
    return false;
});

/**
* Fixed menu from https://bootbites.com/articles/freebie-sticky-bootstrap-navbar-scroll-bootstrap-4
*/
var stickyToggle = function(sticky, stickyWrapper, scrollElement) {
    var stickyHeight = sticky.outerHeight();
    var stickyTop = stickyWrapper.offset().top + sticky.data('delay');
    if (scrollElement.scrollTop() >= stickyTop){
        //stickyWrapper.height(stickyHeight);
        sticky.addClass("is-sticky");
    }
    else{
        sticky.removeClass("is-sticky");
        //stickyWrapper.height('auto');
    }
};
// Find all data-toggle="sticky-onscroll" elements
$('[data-toggle="sticky-onscroll"]').each(function() {
    var sticky = $(this);
    var stickyWrapper = $('<div>').addClass('sticky-wrapper'); // insert hidden element to maintain actual top offset on page
    sticky.before(stickyWrapper);
    sticky.addClass('sticky');
    
    // Scroll & resize events
    $(window).on('scroll.sticky-onscroll resize.sticky-onscroll', function() {
        stickyToggle(sticky, stickyWrapper, $(this));
    });
    // On page load
    stickyToggle(sticky, stickyWrapper, $(window));
});


/**
* Paralax paroller
*/
// $('.home-service [class^="icon-"]').each(function() {
//     $(this).paroller();
// });
// $('.paralax').paroller();


/**
* Mobile main men background color
*/
$("#layout-header .navbar").on("show.bs.collapse", function(e) {
    $("header#layout-header nav.navbar").addClass('open');
});

$("#layout-header .navbar").on("hide.bs.collapse", function(e) {
    $("header#layout-header nav.navbar").removeClass('open');
});


/**
* Service fullscreen menu
*/
$(".service-link").on("click", function(e) {
    e.preventDefault();
    $('.service-menu-container').addClass('show');
    $('body').addClass('overflow-y-hidden').removeClass('overflow-auto');
});
$("aside.service-menu-container .service-menu a.closing").on("click", function(e) {
    e.preventDefault();
    $('.service-menu-container').removeClass('show');
    $('body').addClass('overflow-auto').removeClass('overflow-y-hidden');
})




//end config
let choice = 'join';
let estimate_choice = $("#estimate-step-one .estimate-group-choice").children('.estimate-btn').first().data("value");
let second_estimate_choice = $("#estimate-step-two .estimate-group-choice").children('.estimate-btn').first().data("value");
$("#join-choice-btn").on("click",function(e) {
    e.preventDefault();
    initChoicesBtn();
    $(this).addClass('choice-active');
    choice = 'join';
});
$("#estimate-choice-btn").on("click",function(e) {
    e.preventDefault();
    initChoicesBtn();
    $(this).addClass('choice-active');
    choice = 'estimate';
});
$("#greeting-choice-btn").on("click",function(e) {
    e.preventDefault();
    initChoicesBtn();
    $(this).addClass('choice-active');
    choice = 'greeting';
});

$("#pfe-choice-btn").on("click",function(e) {
    e.preventDefault();
    initChoicesBtn();
    $(this).addClass('choice-active');
    choice = 'pfe';
});


$('.choice-group .next-btn').on("click",function(e){
    e.preventDefault();
    $(".custom-container #choice-group").hide();
    switch(choice) {
        case 'join':
        $("#join-form").show();
        $(".process-pourcentage").width("100%");
        break;
        case 'estimate':
        $(".estimate-group#estimate-step-one").show();
        $(".process-pourcentage").width("25%");
        break;
        case 'pfe':
        $("#pfe-form").show();
        $(".process-pourcentage").width("100%");
        break;
        default:
        $("#hello-form").show();
        $(".process-pourcentage").width("100%");
    }
});
$("#estimate-step-one .estimate-group-choice .estimate-btn").on("click",function(e) {
    e.preventDefault();
    initEstimateChoiceBtn();
    $(this).addClass('choice-active');
    estimate_choice = $(this).data("value");
    $('#form-estimate input#device').attr('value', estimate_choice);
});
$('#estimate-step-one .next-btn').on("click",function(e){
    e.preventDefault();
    $(".custom-container #estimate-step-one").hide();
    switch(estimate_choice) {
        case 'desktop':
        break;
        case 'mobile':
        break;
        default:
        
    }
    $(".process-pourcentage").width("50%");
    $('#estimate-step-one').hide();
    $('#estimate-step-two').show();
});
$('#estimate-step-two .next-btn').on("click",function(e){
    e.preventDefault();
    $(".custom-container #estimate-step-one").hide();
    switch(second_estimate_choice) {
        case 'backEnd':
        break;
        case 'frontEnd':
        break;
        default:
    }
    $(".process-pourcentage").width("100%");
    $('#estimate-step-two').hide();
    $('#estimate-step-three').show();
});
$("#estimate-step-two .estimate-group-choice .estimate-btn").on("click",function(e) {
    e.preventDefault();
    initSecondEstimateChoiceBtn();
    $(this).addClass('choice-active');
    second_estimate_choice = $(this).data("value");
    $('#form-estimate input#scope').attr('value', second_estimate_choice);
});
$("#estimate-step-one .back-arrow").on("click",function(e){
    $(".process-pourcentage").width("90%");
    $("#estimate-step-one").hide();
    $("#choice-group").show();
});
$("#estimate-step-two .back-arrow").on("click",function(e){
    $(".process-pourcentage").width("25%");
    $("#estimate-step-two").hide();
    $("#estimate-step-one").show();
});
$("#estimate-step-three .back-arrow").on("click",function(e){
    $(".process-pourcentage").width("75%");
    $("#estimate-step-three").hide();
    $("#estimate-step-two").show();
});
$("#hello-form .back-arrow").on("click",function(e){
    $(".process-pourcentage").width("90%");
    $("#hello-form").hide();
    $("#choice-group").show();
});
$("#join-form .back-arrow").on("click",function(e){
    $(".process-pourcentage").width("90%");
    $("#join-form").hide();
    $("#choice-group").show();
});
$("#join-form .back-arrow").on("click",function(e){
    $(".process-pourcentage").width("90%");
    $("#join-form").hide();
    $("#choice-group").show();
});



$("#pfe-form .back-arrow").on("click",function(e){
    $(".process-pourcentage").width("90%");
    $("#pfe-form").hide();
    $("#choice-group").show();
});


var afile = [] ;		
var myDropzone;		
var afile = [] ;		
var myDropzonepfe;

$("#dZUpload").dropzone({
    paramName: "piece_joints[]",
    maxFiles: 2000,
    autoProcessQueue:false,
    uploadMultiple: true,
    addRemoveLinks:true,
    parallelUploads: 20,
    acceptedFiles: ".pdf,.doc,.docx",
    url: '/contact',
    init: function () {
      /*  console.log('init');  */
       
      /*  this.on("addedfile", function(file) {
            //file.toString = function(){console.log(this);return "{'f'}";}
            afile.push(file);
          });
        this.on('removedfile', function(file) {
            //file.toString = function(){console.log(this);return "{'f'}";}
                $.grep( afile, function( n, i ) {
                    return n != file;
                }, true );
                console.log('remove',afile);
                console.log(file);
          });*/
    },
    headers: {
        'X-OCTOBER-REQUEST-HANDLER': 'onJoin',
        'X-OCTOBER-REQUEST-FLASH': '1',
    }
});
$("#pfedZUpload").dropzone({
    paramName: "piece_joints[]",
    maxFiles: 2000,
    autoProcessQueue:false,
    uploadMultiple: true,
    addRemoveLinks:true,
    parallelUploads: 20,
    acceptedFiles: ".pdf,.doc,.docx",
    url: '/contact',
    headers: {
        'X-OCTOBER-REQUEST-HANDLER': 'onPfe',
        'X-OCTOBER-REQUEST-FLASH': '1',
    }
});

var txtjoinsubmit = $('#joinSubmit').text();
$("#join-form").on("submit",function(e, response){
    e.preventDefault();
    var myDropzone = Dropzone.forElement("#dZUpload");
    var spvalidate = false;
    if(myDropzone.files.length == 0 || (myDropzone.getAcceptedFiles().length != myDropzone.files.length))
    {
        $('#dZUpload').addClass('has-error');
        $('#dZUpload').parent().find('label').addClass('text-error');
    }else{
        $('#dZUpload').removeClass('has-error');
        $('#dZUpload').parent().find('label').removeClass('text-error');
    }

    var countjoin    = $("#joinfirstname ,#joinsecondname,#joinemail,#joinmessage").length;
    var ijoin        = 0;

    var emailinput = $('#joinemail').val();
    var emailReg =/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                 
    if(false === emailReg.test(emailinput) )
    {
        $('#joinemail').addClass('has-error');
        $('#joinemail').parent().find('label').addClass('text-error');
        ijoin--;
    }else
    {
        $('#joinemail').removeClass('has-error');
        $('#joinemail').parent().find('label').removeClass('text-error');
        ijoin++;
    }
  
    $("#joinfirstname ,#joinsecondname,#joinmessage").each(function(el){
        if($(this).val().length<3)
        {
            $(this).addClass('has-error');
            $(this).parent().find('label').addClass('text-error');
            ijoin--;
        }else{
            $(this).removeClass('has-error');
            $(this).parent().find('label').removeClass('text-error');
            ijoin++;
        }
    })

    var item= {};
    var count = myDropzone.getAcceptedFiles().length;
    if(count > 0 && count < 4 && myDropzone.files.length == count && ijoin == countjoin  )
    {
        $('#joinSubmit').html('<img width="24" src="/themes/satoripop/assets/images/loader.svg"></img>'+txtjoinsubmit).attr("disabled","disabled");
              
        $.each(myDropzone.getAcceptedFiles(),function(k,v){
            //$item.push(v);
            var itm = 'piece_joint_'+k;
            item[itm] = v;
            if (k+1 === count) {
                
              
                $data = item;
               $data.firstname  = $('#joinfirstname').val();
               $data.secondname =  $('#joinsecondname').val();
               $data.email      =  $('#joinemail').val();
               $data.message    =  $('#joinmessage').val();
               $data.validate   = 1;
               $(this).request('onJoin', 
                {
                    ajaxBeforeSend:function(e, r){
                       /* console.log(e,r);*/
                    },
                    data:$data,
                    files:true,
                    success: function(e,r){
                        $.oc.flashMsg({text: 'Contact saved!', 'class': 'success', 'interval': 5});
                        window.location.replace('/thanks');


                        $('#joinSubmit').html(txtjoinsubmit);
                        
                
                        this.success(e,r)
                        .done(function() {
                               
                                if(typeof e.errors !="undefined" && e.errors.length > 0)
                                {
                                    console.log(e,r);
                                   // $("#pfe-form .next-btn").html(txtpfesubmit).css('opacity',1);
                                   $('#joinSubmit').html(txtpfesubmit);
                                    $("#joinSubmit").removeAttr('disabled');
                                   
                                }else
                                {
                                    $('#joinSubmit').html(txtpfesubmit);
                                    window.location.replace('/thanks');
                                  
                                }
                        });




                    },
                    error: function(e,r){
                        /*console.log(e,r);*/
                    },
                    flash: 1,
                    handleFlashMessage: function(message, type) {
                        $.oc.flashMsg({ text: message, class: type })
                    },
                    handleRedirectResponse:function(url)
                    {
                        
                    }
                });
            }
            
    
        });
    }
    

        
});

var txtpfesubmit = $('#pfeSubmit').text();
$("#form-pfe").on("submit",function(e){

    e.preventDefault();
    $('#projectconfirm').addClass('d-none').removeClass('d-flex');
    var myDropzonepfe = Dropzone.forElement("#pfedZUpload");
    if(myDropzonepfe.files.length == 0 || (myDropzonepfe.getAcceptedFiles().length != myDropzonepfe.files.length))
    {
        $('#pfedZUpload').addClass('has-error');
        $('#pfedZUpload').parent().find('label').addClass('text-error');
    }else{
        $('#pfedZUpload').removeClass('has-error');
        $('#pfedZUpload').parent().find('label').removeClass('text-error');
    }
    

    var countpfe    = $("#pfefirstname ,#pfesecondname ,#pfemail, #pfesubject").length;
    var ipfe        = 0;
            
    if($('#pfesubject').find('option:selected').val() > 0)
    {
        $('#pfesubject').removeClass('has-error');
        $('#pfesubject').parent().find('label').removeClass('text-error');
        ipfe++;
    }else
    {
        $('#pfesubject').addClass('has-error');
        $('#pfesubject').parent().find('label').addClass('text-error');
        ipfe--
    }

    $("#pfefirstname ,#pfesecondname ,#pfemail").each(function(){
       
        if($(this).val()== "" || $(this).val().length < 3)
        {
            $(this).addClass('has-error');
            $(this).parent().find('label').addClass('text-error');
            ipfe--;
           
        }else{
            
            $(this).removeClass('has-error');
            $(this).parent().find('label').removeClass('text-error');

            if($(this).attr('type') == 'email')
            {
                var userinput = $(this).val();
                 
                 var emailReg =/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                 
                 if(false === emailReg.test(userinput) )
                 {
                    $(this).addClass('has-error');
                    $(this).parent().find('label').addClass('text-error');
                 }
                 ipfe--;
                 
            }
        }
        ipfe++;
    })

   

if(ipfe+1 == countpfe)
{
    var item= {};
    var count = myDropzonepfe.getAcceptedFiles().length;
    if(count > 0 && count < 4 && myDropzonepfe.files.length == count)
    {
        $.each(myDropzonepfe.getAcceptedFiles(),function(k,v){
            //$item.push(v);
            var itm = 'piece_joint_'+k;
            item[itm] = v;
            if (k+1 === count) {

                
                $('#pfeSubmit').html('<img width="24" src="/themes/satoripop/assets/images/loader.svg"></img>'+txtpfesubmit).attr("disabled","disabled");
               $data = item;
               $data.pfefirstname  = $('#pfefirstname').val();
               $data.pfesecondname =  $('#pfesecondname').val();
               $data.pfemail      =  $('#pfemail').val();
               $data.pfemessage    =  $('#pfemessage').val();
               $data.pfesubject    =  $('#pfesubject option:selected').val();
               
               $data.validate   = 1;
               
               $(this).request('onPfe', 
                {
                    data:$data,
                    files:true,
                    success: function(e,r){
                       
                       
                        $("#pfe-form .next-btn").html(txtpfesubmit);
                        
                
                        this.success(e,r)
                        .done(function() {
                               
                                if(typeof e.errors !="undefined" && e.errors.length > 0)
                                {
                                    console.log(e,r);
                                   // $("#pfe-form .next-btn").html(txtpfesubmit).css('opacity',1);
                                   $('#pfeSubmit').html(txtpfesubmit);
                                    $("#pfe-form .next-btn").removeAttr('disabled');
                                    $('#projectconfirm').removeClass('d-none').addClass('d-flex');
                                }else
                                {
                                    $('#pfeSubmit').html(txtpfesubmit);
                                    window.location.replace('/thanks');
                                    console.log("redirect");
                                }
                        });
                    },
                    complete: function(){
                        
                    },
                    error: function(){
                    },
                    flash: 1,
                    handleFlashMessage: function() {
                      //  console.log(message);
                        //$.oc.flashMsg({ text: message, class: type })
                    },
                    handleRedirectResponse:function()
                    {
                        
                    }
                });
            }
            
    
        });
    }
}
    
    

        
});




 


});
function initChoicesBtn()
{
    choice = '';
    $("#join-choice-btn").removeClass('choice-active');
    $("#estimate-choice-btn").removeClass('choice-active');
    $("#greeting-choice-btn").removeClass('choice-active');
    $("#pfe-choice-btn").removeClass('choice-active');
    
}
function initEstimateChoiceBtn()
{
    estimate_choice = '';
    $("#estimate-step-one .estimate-group-choice .estimate-btn").removeClass('choice-active');
}
function initSecondEstimateChoiceBtn()
{
    second_estimate_choice = '';
    $("#estimate-step-two .estimate-group-choice .estimate-btn").removeClass('choice-active');
}



;(function(window) {
    'use strict';
    
    var Waves = Waves || {};
    var $$ = document.querySelectorAll.bind(document);
    
    // Find exact position of element
    function isWindow(obj) {
        return obj !== null && obj === obj.window;
    }
    
    function getWindow(elem) {
        return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
    }
    
    function offset(elem) {
        var docElem, win,
        box = {top: 0, left: 0},
        doc = elem && elem.ownerDocument;
        
        docElem = doc.documentElement;
        
        if (typeof elem.getBoundingClientRect !== typeof undefined) {
            box = elem.getBoundingClientRect();
        }
        win = getWindow(doc);
        return {
            top: box.top + win.pageYOffset - docElem.clientTop,
            left: box.left + win.pageXOffset - docElem.clientLeft
        };
    }
    
    function convertStyle(obj) {
        var style = '';
        
        for (var a in obj) {
            if (obj.hasOwnProperty(a)) {
                style += (a + ':' + obj[a] + ';');
            }
        }
        
        return style;
    }
    
    var Effect = {
        
        // Effect delay
        duration: 750,
        
        show: function(e, element) {
            
            // Disable right click
            if (e.button === 2) {
                return false;
            }
            
            var el = element || this;
            
            // Create ripple
            var ripple = document.createElement('div');
            ripple.className = 'waves-ripple';
            el.appendChild(ripple);
            
            // Get click coordinate and element witdh
            var pos         = offset(el);
            var relativeY   = (e.pageY - pos.top);
            var relativeX   = (e.pageX - pos.left);
            var scale       = 'scale('+((el.clientWidth / 100) * 10)+')';
            
            // Support for touch devices
            if ('touches' in e) {
                relativeY   = (e.touches[0].pageY - pos.top);
                relativeX   = (e.touches[0].pageX - pos.left);
            }
            
            // Attach data to element
            ripple.setAttribute('data-hold', Date.now());
            ripple.setAttribute('data-scale', scale);
            ripple.setAttribute('data-x', relativeX);
            ripple.setAttribute('data-y', relativeY);
            
            // Set ripple position
            var rippleStyle = {
                'top': relativeY+'px',
                'left': relativeX+'px'
            };
            
            ripple.className = ripple.className + ' waves-notransition';
            ripple.setAttribute('style', convertStyle(rippleStyle));
            ripple.className = ripple.className.replace('waves-notransition', '');
            
            // Scale the ripple
            rippleStyle['-webkit-transform'] = scale;
            rippleStyle['-moz-transform'] = scale;
            rippleStyle['-ms-transform'] = scale;
            rippleStyle['-o-transform'] = scale;
            rippleStyle.transform = scale;
            rippleStyle.opacity   = '1';
            
            rippleStyle['-webkit-transition-duration'] = Effect.duration + 'ms';
            rippleStyle['-moz-transition-duration']    = Effect.duration + 'ms';
            rippleStyle['-o-transition-duration']      = Effect.duration + 'ms';
            rippleStyle['transition-duration']         = Effect.duration + 'ms';
            
            rippleStyle['-webkit-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            rippleStyle['-moz-transition-timing-function']    = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            rippleStyle['-o-transition-timing-function']      = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            rippleStyle['transition-timing-function']         = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
            
            ripple.setAttribute('style', convertStyle(rippleStyle));
        },
        
        hide: function(e) {
            TouchHandler.touchup(e);
            
            var el = this;
            
            // Get first ripple
            var ripple = null;
            var ripples = el.getElementsByClassName('waves-ripple');
            if (ripples.length > 0) {
                ripple = ripples[ripples.length - 1];
            } else {
                return false;
            }
            
            var relativeX   = ripple.getAttribute('data-x');
            var relativeY   = ripple.getAttribute('data-y');
            var scale       = ripple.getAttribute('data-scale');
            
            // Get delay beetween mousedown and mouse leave
            var diff = Date.now() - Number(ripple.getAttribute('data-hold'));
            var delay = 350 - diff;
            
            if (delay < 0) {
                delay = 0;
            }
            
            // Fade out ripple after delay
            setTimeout(function() {
                var style = {
                    'top': relativeY+'px',
                    'left': relativeX+'px',
                    'opacity': '0',
                    
                    // Duration
                    '-webkit-transition-duration': Effect.duration + 'ms',
                    '-moz-transition-duration': Effect.duration + 'ms',
                    '-o-transition-duration': Effect.duration + 'ms',
                    'transition-duration': Effect.duration + 'ms',
                    '-webkit-transform': scale,
                    '-moz-transform': scale,
                    '-ms-transform': scale,
                    '-o-transform': scale,
                    'transform': scale,
                };
                
                ripple.setAttribute('style', convertStyle(style));
                
                setTimeout(function() {
                    try {
                        el.removeChild(ripple);
                    } catch(e) {
                        return false;
                    }
                }, Effect.duration);
            }, delay);
        },
        
        // Little hack to make <input> can perform waves effect
        wrapInput: function(elements) {
            for (var a = 0; a < elements.length; a++) {
                var el = elements[a];
                
                if (el.tagName.toLowerCase() === 'input') {
                    var parent = el.parentNode;
                    
                    // If input already have parent just pass through
                    if (parent.tagName.toLowerCase() === 'i' && parent.className.indexOf('waves-effect') !== -1) {
                        continue;
                    }
                    
                    // Put element class and style to the specified parent
                    var wrapper = document.createElement('i');
                    wrapper.className = el.className + ' waves-input-wrapper';
                    
                    var elementStyle = el.getAttribute('style');
                    
                    if (!elementStyle) {
                        elementStyle = '';
                    }
                    
                    wrapper.setAttribute('style', elementStyle);
                    
                    el.className = 'waves-button-input';
                    el.removeAttribute('style');
                    
                    // Put element as child
                    parent.replaceChild(wrapper, el);
                    wrapper.appendChild(el);
                }
            }
        }
    };
    
    
    /**
    * Disable mousedown event for 500ms during and after touch
    */
    var TouchHandler = {
        /* uses an integer rather than bool so there's no issues with
        * needing to clear timeouts if another touch event occurred
        * within the 500ms. Cannot mouseup between touchstart and
        * touchend, nor in the 500ms after touchend. */
        touches: 0,
        allowEvent: function(e) {
            var allow = true;
            
            if (e.type === 'touchstart') {
                TouchHandler.touches += 1; //push
            } else if (e.type === 'touchend' || e.type === 'touchcancel') {
                setTimeout(function() {
                    if (TouchHandler.touches > 0) {
                        TouchHandler.touches -= 1; //pop after 500ms
                    }
                }, 500);
            } else if (e.type === 'mousedown' && TouchHandler.touches > 0) {
                allow = false;
            }
            
            return allow;
        },
        touchup: function(e) {
            TouchHandler.allowEvent(e);
        }
    };
    
    
    /**
    * Delegated click handler for .waves-effect element.
    * returns null when .waves-effect element not in "click tree"
    */
    function getWavesEffectElement(e) {
        if (TouchHandler.allowEvent(e) === false) {
            return null;
        }
        
        var element = null;
        var target = e.target || e.srcElement;
        
        while (target.parentElement !== null) {
            if (!(target instanceof SVGElement) && target.className.indexOf('waves-effect') !== -1) {
                element = target;
                break;
            } else if (target.classList.contains('waves-effect')) {
                element = target;
                break;
            }
            target = target.parentElement;
        }
        
        return element;
    }
    
    /**
    * Bubble the click and show effect if .waves-effect elem was found
    */
    function showEffect(e) {
        var element = getWavesEffectElement(e);
        
        if (element !== null) {
            Effect.show(e, element);
            
            if ('ontouchstart' in window) {
                element.addEventListener('touchend', Effect.hide, false);
                element.addEventListener('touchcancel', Effect.hide, false);
            }
            
            element.addEventListener('mouseup', Effect.hide, false);
            element.addEventListener('mouseleave', Effect.hide, false);
        }
    }
    
    Waves.displayEffect = function(options) {
        options = options || {};
        
        if ('duration' in options) {
            Effect.duration = options.duration;
        }
        
        //Wrap input inside <i> tag
        Effect.wrapInput($$('.waves-effect'));
        
        if ('ontouchstart' in window) {
            document.body.addEventListener('touchstart', showEffect, false);
        }
        
        document.body.addEventListener('mousedown', showEffect, false);
    };
    
    /**
    * Attach Waves to an input element (or any element which doesn't
    * bubble mouseup/mousedown events).
    *   Intended to be used with dynamically loaded forms/inputs, or
    * where the user doesn't want a delegated click handler.
    */
    Waves.attach = function(element) {
        //FUTURE: automatically add waves classes and allow users
        // to specify them with an options param? Eg. light/classic/button
        if (element.tagName.toLowerCase() === 'input') {
            Effect.wrapInput([element]);
            element = element.parentElement;
        }
        
        if ('ontouchstart' in window) {
            element.addEventListener('touchstart', showEffect, false);
        }
        
        element.addEventListener('mousedown', showEffect, false);
    };
    
    window.Waves = Waves;
    
    document.addEventListener('DOMContentLoaded', function() {
        Waves.displayEffect();
    }, false);
    
})(window);



// WEBPACK FOOTER //
// ./themes/satoripop/assets/js/app.js